//Variables del componente Authenticator Amplify
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import '../i18n/Translations';
import {Helmet} from "react-helmet";
import { Amplify, Hub } from 'aws-amplify';
import { Authenticator} from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import '../css/helias-login.css';
import awsExports from '../config/aws-exports.js';
import Loader from '../components/Utils/Loader';
import FooterLogin from '../components/Login/FooterLogin'
import { useEffect } from 'react';
import InitialCheck from './InitialCheck';
import UserTypeSelection from './UserTypeSelection';
import UserWelcome from './User/InitialConfig/Welcome';
import UserGeneralInfo from './User/InitialConfig/GeneralInfo'; 
import Meteo from './User/InitialConfig/Meteo';
import InstallationElements from './User/InitialConfig/InstallationElements';
import FV from './User/InitialConfig/FV';
import Battery from './User/InitialConfig/Battery';
import Generator from './User/InitialConfig/Generator';
import Devices from './User/InitialConfig/Devices';
import Cars from './User/InitialConfig/Cars';
import UserMessaging from './User/InitialConfig/Messaging';
import UserFinalStep from './User/InitialConfig/FinalStep';
import Main from './User/Main';
import PublicMain from './Public/PublicMain.js';
import Last12BillsAnalysis from './Public/Last12BillsAnalysis.js'
import InstallerWelcome from './Installer/InitialConfig/Welcome';
import InstallerGeneralInfo from './Installer/InitialConfig/GeneralInfo';
import InstallerMessaging from './Installer/InitialConfig/Messaging';
import InstallerFinalStep from './Installer/InitialConfig/FinalStep';
import InstallerMain from './Installer/Main';
import Logout from './Logout'; 
import ReactGA from "react-ga4";
import HeliasAvatar from '../img/dark-theme/helias-avatar.png'
import FooterHelias from '../img/dark-theme/fevergy-brand.svg'
import Cookies from 'js-cookie';
import NoInternetConnection from '../components/Utils/NoInternetConnection.js';

Amplify.configure(awsExports);

var endpoint = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"

var generalCommonJS = require("../js/generalCommon.js")

const components = {

    Header() {
      return (       
        <header className="helias-logo"><a href="https://helias.fevergy.com"><span>Helias</span></a></header>          
      );
    },
  
    Footer() {
      return (               
        <FooterLogin/>          
      );
    }
}

const formFields = {  
  signUp: {
    phone_number: {
      dialCode: '+34'
    },
  },
}

function Login(){

  useEffect(() => {     
    
    document.title = "HELIAS - Acceso y registro" 
    
    if (window.location.href.includes("fevergy")){ //En producción dehabilito los console.log
      console.log = () => {};
    }      

    const handleUnload = () => { //Controlo algunas casuísticas de flujos pre-acceso      
      validarProcesoVerificacion() 
    };
    
    document.querySelector('meta[name="viewport"]').setAttribute("content", "width=device-width, initial-scale=1, viewport-fit=cover");
    
    //Corrijo márgenes superiores pen función del tipo de dispositivo
    var tipoDispositivoMovil = generalCommonJS.obtenerTipoPlataforma()

    //Realizo ajustes Knoch según plataforma

    if( tipoDispositivoMovil === "iOS" ){ 
      document.documentElement.setAttribute('ios','') // Para iOS amplio de arriba y reduzco de abajo
      //window.scrollTo(0, window.scrollY + 50) //Autoscroll para mitigar el espacio negro
    }
    else if( tipoDispositivoMovil === "Android" ){ 
      document.documentElement.setAttribute('android','') // Para Android reduzco de arriba    
    }
    else{ 
      document.documentElement.setAttribute('web','') // Para web no hago nada    
    } 

    //Muestro Web to App según plataforma

    if( ( tipoDispositivoMovil === "Android Mobile - Web" ) && (!window.location.href.includes("/Asesoramiento")) ){       
      document.getElementById("webToApp").className = document.getElementById("webToApp").className.replaceAll(" hidden", "") // Muestro el Web to App
    }
    else if( ( tipoDispositivoMovil === "iOS Mobile - Web") && (!window.location.href.includes("/Asesoramiento")) ){     
      document.getElementById("webToApp").className = document.getElementById("webToApp").className.replaceAll(" hidden", "") // Muestro el Web to App
    }
    else{       
      document.getElementById("webToApp").className = document.getElementById("webToApp").className.replaceAll(" hidden", "") + " hidden" // Oculto el Web to App
    }     

    //Control actividad Google Analytics en navegaciones renderizadas            
    generalCommonJS.visibilidadCookies(ReactGA,Cookies)    
    generalCommonJS.registrarEventoAnalitica(ReactGA, 'LOGIN', 'Acceso pantalla de login', "", "")
    
    window.addEventListener('unload', handleUnload);

    if(localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser") === null){
      window.history.pushState('', '', '/')
    }

    console.log("Login cargado")   

    return () => {
      window.removeEventListener('unload', handleUnload); 
    };

  }); 

  function validarProcesoVerificacion(){

    var formularios = document.querySelectorAll('form');

    for (var x = 0 ; x < formularios.length; x++){          
      for (var y = 0 ; y < formularios[x].attributes.length; y++){
        if(formularios[x].attributes[y].name.includes("verifyuser")){          
          generalCommonJS.limpiarDatosSesion()          
        }                        
      }
    }

  }

  const listener = (data) => { 

    //https://docs.amplify.aws/lib/auth/auth-events/q/platform/react-native/

    

    switch (data.payload.event) {
      case 'configured': 
        console.log('the Auth module is configured');      
        break;
      case 'signIn':
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'LOGIN', 'LOGIN - Login correcto', "", "") 
        break;
      case 'signIn_failure': 
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'LOGIN', 'LOGIN - Login erróneo', "", "")     
        break;
      case 'signUp':
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'REGISTRO', 'REGISTRO - Registro correcto', "", "")
        localStorage.setItem("showInitialHelp", "true")
        sendEmailRegistroCorrecto(data.payload.data.user.username)   
        break;
      case 'signUp_failure':
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'REGISTRO', 'REGISTRO - Registro fallido', "", "")
        sendEmailIntentoRegistro()        
        break;
      case 'confirmSignUp':
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'REGISTRO', 'REGISTRO - Confirmación OK', "", "")   
        break;
      case 'completeNewPassword_failure':
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'CAMBIO_CONTRASEÑA', 'CAMBIO PWD - Nueva KO', "", "") 
        break;
      case 'autoSignIn':
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'LOGIN', 'LOGIN - SSO Correcto', "", "")     
        break;
      case 'autoSignIn_failure': 
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'LOGIN', 'LOGIN - SSO Fallido', "", "")     
        break;
      case 'forgotPassword':
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'CAMBIO_CONTRASEÑA', 'CAMBIO PWD - Correcto', "", "")        
        break;
      case 'forgotPassword_failure':
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'CAMBIO_CONTRASEÑA', 'CAMBIO PWD - Fallido', "", "")        
        break;
      case 'forgotPasswordSubmit':
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'CAMBIO_CONTRASEÑA', 'CAMBIO PWD - Solicitud OK', "", "")        
        break;
      case 'forgotPasswordSubmit_failure':
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'CAMBIO_CONTRASEÑA', 'CAMBIO PWD - Solicitud KO', "", "")        
        break;
      case 'verify':
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'CAMBIO_CONTRASEÑA', 'CAMBIO PWD - Verif. OTP OK', "", "")        
        break;
      case 'tokenRefresh':
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'TOKEN_REFRESH', 'TOKEN REFRESH - Correcto', "", "")        
        break;
      case 'tokenRefresh_failure':
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'TOKEN_REFRESH', 'TOKEN REFRESH - Incorrecto', "", "")        
        break;
      case 'cognitoHostedUI':
        console.log('Cognito Hosted UI sign in successful');        
        break;
      case 'cognitoHostedUI_failure':
        console.log('Cognito Hosted UI sign in failed');        
        break;
      case 'customOAuthState':
        console.log('custom state returned from CognitoHosted UI');        
        break;
      case 'customState_failure':
        console.log('custom state failure');        
        break;
      case 'parsingCallbackUrl':
        console.log('Cognito Hosted UI OAuth url parsing initiated');        
        break;
      case 'userDeleted':
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'BORRAR_USUARIO', 'BORRADO USUARIO - Correcto', "", "")        
        break;
      case 'updateUserAttributes':
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'MODIFICACIÓN_USUARIO', 'MODIF. USUARIO - Correcta', "", "")        
        break;
      case 'updateUserAttributes_failure':
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'MODIFICACIÓN_USUARIO', 'MODIF. USUARIO - Incorrecta', "", "")        
        break;
      case 'signOut':
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'LOGOUT', 'LOGOUT - Correcto', "", "")        
        break;
      default:
        console.log("Evento Authenticator no identificado")        
    }
  };
  
  Hub.listen('auth', listener);

  function sendEmailIntentoRegistro(){

    var plataforma = generalCommonJS.obtenerTipoPlataforma()
    var email = document.getElementsByName("email")[0].value   
    var nombre = document.getElementsByName("name")[0].value
    var apellidos = document.getElementsByName("family_name")[0].value
    var prefijo = document.getElementsByName("country_code")[0].value
    var numeroTelefono = document.getElementsByName("phone_number")[0].value

    // Defino los headers de la petición
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
  
    // Defino el JSON de la petición de insercción
    var raw = JSON.stringify({
      "asuntoEmail": "HELIAS: Intento de registro "+email,
      "destinatario": "soporte@fevergy.com",
      "mensaje": email+"###"+plataforma+"<BR>"+email+"<BR>"+nombre+"<BR>"+apellidos+"<BR>"+prefijo+" "+numeroTelefono,
      "origen": "APP"
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
  
    // realizamos la petición de insercción usando promesas
    fetch(endpoint+"/Helias/V0/Messaging/postEmail", requestOptions)
    .then(response => response.text() )
    .then(result => {})
    .catch(error => {});
    
  }

  function sendEmailRegistroCorrecto(email){

    var plataforma = generalCommonJS.obtenerTipoPlataforma()
    
    // Defino los headers de la petición
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
  
    // Defino el JSON de la petición de insercción
    var raw = JSON.stringify({
      "asuntoEmail": "HELIAS: Se ha registrado un nuevo usuario - "+email,
      "destinatario": "soporte@fevergy.com",
      "mensaje": email+"###<p>Nuevo usuario registrado:</p><p>"+email+" se acaba de registrar en Helias via "+plataforma+".</p>",
      "origen": "APP"
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
  
    // realizamos la petición de insercción usando promesas
    fetch(endpoint+"/Helias/V0/Messaging/postEmail", requestOptions)
    .then(response => response.text() )
    .then(result => {})
    .catch(error => {});
    
  }

  function procesarParametrosIniciales(){
    
    var params=window.location.search.replace("?","").split("&");    
    var paramTemp = "";    
    var paginaInicial = ""

    for(var i = 0; i < params.length; i++) {    
        
      paramTemp = params[i].split("=");
  
      if(paramTemp[0] === "joinus"){            
        paginaInicial="signUp"
      }
      else if( paramTemp[0] === "iID"){ // Si recibo deeplink para acceso directo a una instalación lo seteo
        localStorage.setItem("deepLinkID", paramTemp[1]);                       
      }      
      else if(paramTemp.toString().includes("cookies")){ // Si recibo flag de cookies seteo valor
        
        if(paramTemp[1] === "true"){
          localStorage.setItem("FEVERGY_cookies", "true");      
        }
        else{
          localStorage.setItem("FEVERGY_cookies", "false");      
        }
        
        generalCommonJS.visibilidadCookies()     
      }      
      else{        
        paginaInicial=""
      }
  
    }
  
    localStorage.removeItem("deepLinkID")

    window.history.replaceState({}, document.title, window.location.pathname);    

    return paginaInicial
  
  }

  function accionLimiteSuscripcion(accion){

    var urlAccion = ""

    if(accion === "linkSuscripcionEliminarReglas"){
      urlAccion = "/Rules"
    }
    else if(accion === "linkSuscripcionEliminarAplicaciones"){
      urlAccion = "/InstallationConfiguration/Devices"
    }    
    else if(accion === "linkSuscripcionEliminarCoche"){
      urlAccion = "/InstallationConfiguration/Cars"
    }

    window.location.href = urlAccion

  }

  function salirDinamico(){

    if(localStorage.getItem("installationName").includes("INSTALADOR-")){      
      document.getElementById("volverConsolaInstalador").click()      
      
    }
    else{ //Salir normal      
      window.location.href="/Logout"
    }

  }

  return(       
    <>

      <NoInternetConnection>

        <Helmet> 
          <title></title>          
          <meta name="mobile-web-app-capable" content="yes"/>
          <meta http-equiv='cache-control' content='no-cache'/>
          <meta http-equiv='expires' content='0'/>
          <meta http-equiv='pragma' content='no-cache'/> 
          <meta name="description" content="Helias es tu asistente premium. Te ayuda a controlar tu economía energética y a automatizar lo que necesites en tu instalación para conseguir la mayor eficiencia y ahorro."></meta>
        </Helmet>
        
        { window.location.href.includes("/Asesoramiento") ? 
          <Router >         
            {/* PÁGINAS PÚBLICAS */}
            <Routes >                                            
              <Route path='/Asesoramiento' element={<PublicMain page={"Asesoramiento"}/>} />        
              <Route path='/Asesoramiento/Analisis-12-Facturas' element={<Last12BillsAnalysis page={"Asesoramiento"} selectedOption={"Last12BillsAnalysis"} subOption={""}/>} />                    
              <Route path='/Asesoramiento/Contrato-Luz' element={<PublicMain page={"Asesoramiento"} selectedOption={"EnergyBilling"} subOption={""}/>} />                    
              <Route path='/Asesoramiento/Comunidad-Vecinos' element={<PublicMain page={"Asesoramiento"} selectedOption={"CommunityBilling"} subOption={""}/>} />        
              <Route path='/Asesoramiento/Tarifas-Luz' element={<PublicMain page={"Asesoramiento"} selectedOption={"FeesAnalyzer"} subOption={"Public"}/>} />   
              <Route path='/Asesoramiento/Sustitucion-Electrodomesticos' element={<PublicMain page={"Asesoramiento"} selectedOption={"AppliancesReplacement"} subOption={""}/>} />        
              <Route path='/Asesoramiento/Dispositivos-Inteligentes' element={<PublicMain page={"Asesoramiento"} selectedOption={"ConsumptionControl"} subOption={""}/>} />        
              <Route path='/Asesoramiento/Conectividad' element={<PublicMain page={"Asesoramiento"} selectedOption={"Connectivity"} subOption={""}/>} />        
              <Route path='/Asesoramiento/Paneles-Solares' element={<PublicMain page={"Asesoramiento"} selectedOption={"AlternativeEnergySources"} subOption={""}/>} />        
              <Route path='/Asesoramiento/Baterias' element={<PublicMain page={"Asesoramiento"} selectedOption={"BatteriesInstallation"} subOption={""}/>} />        
              <Route path='/Asesoramiento/Excedente-Energetico' element={<PublicMain page={"Asesoramiento"} selectedOption={"EnergySurplus"} subOption={""}/>} />        
              <Route path='/Asesoramiento/Movilidad-Electrica' element={<PublicMain page={"Asesoramiento"} selectedOption={"AlternativeTransportation"} subOption={""}/>} />        
            </Routes>
          </Router>
        : /* PÁGINAS PRIVADAS */
          <Authenticator hideSignUp={false} initialState={procesarParametrosIniciales()} components={components} formFields={formFields} >

              {() => (                                           

                <Router >            
                  <Routes >                                                
                    <Route path='/' element={<InitialCheck/>} />              
                    <Route path='/UserTypeSelection' element={<UserTypeSelection/>} />              
                    <Route path='/UserInitialConfig/Welcome' element={<UserWelcome/>} />              
                    <Route path='/UserInitialConfig/GeneralInfo' element={<UserGeneralInfo/>} />
                    <Route path='/UserInitialConfig/Meteo' element={<Meteo/>} />
                    <Route path='/UserInitialConfig/InstallationElements' element={<InstallationElements/>} />
                    <Route path='/UserInitialConfig/FV' element={<FV/>} />
                    <Route path='/UserInitialConfig/Battery' element={<Battery/>} />
                    <Route path='/UserInitialConfig/Generator' element={<Generator/>} />
                    <Route path='/UserInitialConfig/Devices' element={<Devices/>} />
                    <Route path='/UserInitialConfig/Cars' element={<Cars/>} />
                    <Route path='/UserInitialConfig/Messaging' element={<UserMessaging/>} />
                    <Route path='/UserInitialConfig/FinalStep' element={<UserFinalStep/>} /> 
                    <Route path='/InstallerInitialConfig/FinalStep' element={<InstallerFinalStep/>} /> 
                    <Route path='/InstallerInitialConfig/Welcome' element={<InstallerWelcome/>} />              
                    <Route path='/InstallerInitialConfig/GeneralInfo' element={<InstallerGeneralInfo/>} />
                    <Route path='/InstallerInitialConfig/Messaging' element={<InstallerMessaging/>} />                    
                    <Route path='/Dashboard' element={<Main page={"Dashboard"}/>} />                            
                    <Route path='/Rules' element={<Main page={"Rules"}/>} />                                             
                    <Route path='/InstallationActivity' element={<Main page={"InstallationActivity"}/>} />
                    <Route path='/Analytics' element={<Main page={"HeliasAnalytics"}/>} />              
                    <Route path='/HistoricalEconomics' element={<Main page={"HistoricalEconomics"}/>} />              
                    <Route path='/InstallationConfiguration' element={<Main page={"InstallationConfiguration"} selectedOption={""}/>} />
                    <Route path='/InstallerInstallationConfiguration' element={<InstallerMain page={"InstallationConfiguration"} selectedOption={""}/>} />              
                    <Route path='/InstallationConfiguration/GeneralInfo' element={<Main page={"InstallationConfiguration"} selectedOption={"GeneralInfo"}/>} />
                    <Route path='/InstallationConfiguration/FV' element={<Main page={"InstallationConfiguration"} selectedOption={"FV"}/>} />              
                    <Route path='/InstallationConfiguration/Devices' element={<Main page={"InstallationConfiguration"} selectedOption={"Devices"}/>} />
                    <Route path='/InstallationConfiguration/Generator' element={<Main page={"InstallationConfiguration"} selectedOption={"Generator"}/>} />              
                    <Route path='/InstallationConfiguration/Cars' element={<Main page={"InstallationConfiguration"} selectedOption={"Cars"}/>} />              
                    <Route path='/InstallationConfiguration/Messaging' element={<Main page={"InstallationConfiguration"} selectedOption={"Messaging"}/>} />              
                    <Route path='/Advisory' element={<Main page={"Advisory"}/>} />                            
                    <Route path='/Advisory/EnergyBilling' element={<Main page={"Advisory"} selectedOption={"EnergyBilling"}/>} />                            
                    <Route path='/Advisory/InstallerFeesAnalyzer' element={<InstallerMain page={"FeesAnalyzer"}/>} />                            
                    <Route path='/Advisory/FeesAnalyzer' element={<Main page={"Advisory"} selectedOption={"FeesAnalyzer"} subOption={""} />} />                            
                    <Route path='/Advisory/FeesAnalyzer/Auto' element={<Main page={"Advisory"} selectedOption={"FeesAnalyzer"} subOption={"Auto"} />} />
                    <Route path='/Advisory/ConsumptionControl' element={<Main page={"Advisory"} selectedOption={"ConsumptionControl"}/>} />                                          
                    <Route path='/Advisory/EnergySurplus' element={<Main page={"Advisory"} selectedOption={"EnergySurplus"}/>} />                            
                    <Route path='/Advisory/BatteriesInstallation' element={<Main page={"Advisory"} selectedOption={"BatteriesInstallation"}/>} />                            
                    <Route path='/InstallerDashboard' element={<InstallerMain page={"Dashboard"}/>} />                            
                    <Route path='/UserAccount' element={<Main page={"UserAccount"} />} />                                                        
                    <Route path='/InstallerUserAccount' element={<InstallerMain page={"UserAccount"} />} />                                                        
                    <Route path='/Support' element={<Main page={"Support"}/>} />                            
                    <Route path='/Logout' element={<Logout/>} />     
                    <Route path="*" element={<InitialCheck/>} />   {/* PARA LAS RUTAS INEXISTENTES REDIRIJO AL INITIALCHECK */}      
                  </Routes>

                  <Loader Id="loaderGeneralAplicacion" Mensaje=""/>

                  <div id="toastInformativo" className="toast" onClick={() => document.getElementById("toastInformativo").className = "toast invisible"}></div>   

                  <div id="divErrorGeneral" className="loader hidden">
                    <section id="sectionErrorGeneral" className="error-container">
                      <div id="divIconoErrorGeneral" className="message error huge">
                        <span id="spanIconErrorGeneral" className="material-icon">report</span> 
                        <h1 id="h1ErrorGeneral" className="title">Se ha producido un error</h1>
                        <p id="textoErrorGeneral"></p>
                      </div>
                      <ul className="actions">
                        <button id="errorReportingButton" className="button primary" >Repórtanos el error</button>
                        <button id="errorBackToHome" className="button primary hidden" onClick={() => window.location.href="/Dashboard"}>Ir a inicio</button>
                        <button id="errorInstallationSelectionButton" className="button primary hidden" >Selecciona otra instalación</button>                  
                        <button id="errorExtendSession" className="button primary hidden" onClick={() => window.location.href="/"}>Extender la sesión</button>                  
                        <button id="errorExitButton" className="button primary" >Salir</button>                  
                      </ul>
                    </section>
                  </div>

                  <div id="divLimitesSuscripcion" className="loader hidden">

                    <section id="sectionLimitesSuscripcion" className="error-container">
                      <div id="divIconoLimitesSuscripcion" className="message error huge">
                        <div className="horizontal-center">
                          <img id="iconoLimitesSuscripcion" src="" alt="Logo suscripción" width="128" className="blink" style={{"--blink-duration": "1.5s"}}/>
                        </div>                                    
                      </div>

                        <div className="bubble vertical-horizontal gap-04 vertical-center full-width">
                          <p id="textoLimitesSuscripcion"></p>
                          <a id="linkLimiteSuscripcionModificar" href="#" className="button primary fill-fit hidden"/>
                        </div>

                        <div id="cuadroEliminacionElementosSuscripcion" className="bubble vertical gap-04 full-width hidden">
                          <p>O puedes mantener tu plan quitando cosas:</p>
                          <fieldset className="red">
                            <button id="botonEliminarReglas" className="forward icon-wrapper hidden" onClick={ () => accionLimiteSuscripcion("linkSuscripcionEliminarReglas")}>
                              <figure className="avatar size-m"><span className="material-icon">rule</span></figure>
                              <span id="spanEliminarReglas" className="fill"></span>
                            </button>
                            <button id="botonEliminarAplicaciones" className="forward icon-wrapper hidden" onClick={ () => accionLimiteSuscripcion("linkSuscripcionEliminarAplicaciones")}>
                              <figure className="avatar size-m"><span className="material-icon">devices_other</span></figure>
                              <span id="spanEliminarAplicaciones" className="fill"></span>
                            </button>                      
                            <button id="botonEliminarCoches" className="forward icon-wrapper hidden" onClick={ () => accionLimiteSuscripcion("linkSuscripcionEliminarCoche")}>
                              <figure className="avatar size-m"><span className="material-icon">directions_car</span></figure>
                              <span id="spanEliminarCoches" className="fill"></span>
                            </button>
                          </fieldset>
                        </div>

                        <button id="linkSeleccionarInstalacionErrorSuscripcion" className="button primary hidden" >Selecciona otra instalación</button>
                        
                        <button id="linkElementosSuscripcionSalir" className="link hidden" onClick={ () => salirDinamico()}></button>                        

                        <button id="linkVolverProblemaSuscripcion" className="link hidden" onClick={ () => document.getElementById("divLimitesSuscripcion").className = document.getElementById("divLimitesSuscripcion").className.replaceAll(" hidden", "") + " hidden"}>Volver</button>

                    </section>
                  </div>

                </Router>        
              )}  

          </Authenticator>   
        }
            
        <div id="webToApp" className="get-app hidden">
          <div className="get-app-container">
            <div className="get-app-helias">
              <img src={HeliasAvatar} alt="Helias"/>
              <div className="baloon">
                <span className="text">Descarga nuestra aplicación móvil para tener la mejor experiencia</span>
              </div>
            </div>
            <button className="button primary" onClick={() => generalCommonJS.abrirFichaApp(generalCommonJS.obtenerTipoPlataforma())}>Descargar</button>
          </div>
          <img src={FooterHelias} className="fevergy" alt="Fevergy"/>
        </div>

        <aside id="asideCookies" style={{display: "none"}}>
          <div className="container">
            <details>
              <summary className="content">
                <figure className="avatar orange size-l"><span className="material-icon">cookie</span></figure>
                <span className="description">Reglamento General de Protección de Datos y Cookies.</span>
                <span className="material-icon">expand_more</span>
              </summary>
              <p className="explanation">Usamos cookies <strong>funcionales</strong> para garantizar el correcto funcionamiento de la aplicación.</p>
              <p className="explanation">También usamos cookies para mostrar <strong>publicidad</strong> durante el periodo de prueba.</p>
              <p className="explanation">Por último usamos cookies para analizar el <strong>comportamiento de los usuarios</strong> y mejorar la aplicación con estos datos (que son anónimos).</p>       
            </details>
            <ul className="actions">
              <li><button className="button primary size-s full-width" onClick={() => generalCommonJS.cookiesAceptarTodas({ReactGA})}>Aceptar</button></li>
              <li><button className="button secondary size-s full-width" onClick={() => generalCommonJS.cookiesSoloFuncionales({Cookies})}>Rechazar</button></li>
            </ul>
          </div>
        </aside>
    
      </NoInternetConnection>    
    </>         
  );
}

export default Login;